import styles from "./CookeModal.module.scss"
import Button from "components/Button/Button";
import React, { FC } from "react";

export const setCookie = (name: string, value: string, days: number) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  document.cookie = `${name}=${value}; Path=/; Expires=${d.toUTCString()}; SameSite=Lax`;

}

export const getCookie = (name: string) => {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
  
}

export const hasConsent = () => getCookie('cookies_accepted') === '1';
export const acceptCookies = () => setCookie('cookies_accepted', '1', 365);



interface CookieModalProps {
  onClick: () => void;
}

export const CookieModal: FC<CookieModalProps> = ({onClick}) => {
    return <div className={styles.wrapper}> 
        <p>Мы обрабатываем <a href="/upload/politika-cookie-summit.pdf" target="_blank" rel="noopener noreferrer" className={styles.a}>cookies</a></p>
        <Button
              className={styles.submitBtn}
              onClick={onClick}
              htmlType="submit"
            >
              Согласен
            </Button>
         </div>
}

export default CookieModal
